<template>
    <div class="page-section">
      <div class="breadcrumbs-custom box-transform-wrap context-dark">
        <div class="container">
          <h3 class="breadcrumbs-custom-title">Oprema</h3>
          <div class="breadcrumbs-custom-decor"></div>
        </div>
        <vue-load-image>
          <div slot="image" alt="slight production oprema slika" class="box-transform" :data-src="require('./../images/oprema/bg-slight-production-oprema.jpg')" :style="{ backgroundImage: 'url(' + require('./../images/oprema/bg-slight-production-oprema.jpg') + ')' }"></div>
          <div slot="preloader" class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>          
          <div slot="error">učitavam sliku...</div>
        </vue-load-image>         
      </div>              
      <section class="section section-md bg-gray-lighter text-center">
        <div class="shell-fluid shell-sidebar-condensed">
          <div class="range range-md-center">
            <div class="cell-md-11 cell-xl-10">
              <h2 class="text-bold">Kvaliteta nam je bitna!</h2>
              <p><span class="box-width-2">Pračenjem novih tehnologija i trendova na tržištu od velikog nam je značaja kako bi Vaš događaj bio besprijekorno odrađen.</span></p>
            </div>
          </div>          
          <div class="range range-30">
            <div  class="news-item" v-for="(newsItem, index) in news" :key="newsItem.id">
              <!-- Post classic-->
              <article class="post-classic">
                <img class="post-classic__image" :src="getSrcLink(index)" alt="" width="506" height="229">
                <div class="post-classic__main">
                  <h3 class="post-classic__title">{{newsItem.Title}}</h3>
                  <div class="post-classic__text">
                    <p>{{newsItem.Description}}</p>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
  </section>          
    </div>
</template>

<script>
import axios from 'axios';
export default {
  metaInfo(){
    return{
      title: 'S light production - oprema, tehnologija i trendovi',
      meta:[
        {
          name: 'description',
          content: 'S light production - pratimo tehnologije i trendova na tržištu. Rasvjeta je, bez obzira na događaj i priliku, značajan čimbenik za potpuni dojam i ugođaj.'
        }
      ]
    }
  },   
   data(){
        return{
            show:true,
            componentLoaded: false,
            news:''
        }
   },
   methods:{
        fetchData(){
            axios({
              method: 'get',
              url: this.apiPath +'news/readOpremaPageNews.php'
            })
            .then(function(response) {
                this.news = response.data;
                this.componentLoaded = true;                
            }.bind(this))
            .catch((error) => {
                console.log(error);
            });             
        }
   },
   computed: {
        getSrcLink: function() {
            return function(id) {
            if(! this.componentLoaded)
                return null;

             return this.dataPath + 'oprema_photos/' + this.news[id].Image;
            }
        }        
   },   
   created(){
       this.fetchData();
   }
}
</script>

<style lang="scss">
.page{
    .header-image{
    position: relative;
    overflow: hidden;
    z-index: 1; 
    color: #ffffff; 
    padding: 90px 0;    
    text-align: center;
      .bg-image{
        position: absolute;
        right: 0;
        top: 0;
        width: calc(100% + 150px);
        height: 450px;
        will-change: transform;
        animation: bgPos 100s linear infinite;
        transform: translate3d(75px, -75px, 0) rotate(0.001deg);
        background-size: cover;
        pointer-events: none;
        zoom: 1;
        z-index: -1;
      }
      .container{
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
        text-align: center;
        .title{
          color:#fff;
          font-weight: 700;
          font-size: 44px;
          line-height: 1.22727;
          margin-top: 0;
          margin-bottom: 0;
          letter-spacing: .1em;
          text-transform: uppercase;
          font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif;
        } 
        .custom-decor{
          margin-top: 35px;
          font-size: 0;
          line-height: 0;
          &::before{
            display: inline-block;
            content: '';
            width: 72px;
            height: 4px;
            background: rgba(255, 255, 255, 0.6);            
          }
        }       
      }
    }
  section{  
    .shell-fluid{
      max-width: 90%;
      margin: auto;
      .range{
        .news-item{
          max-width:32%;
          padding: 0;
          margin-right: 2%;
          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 991px) {
  .page{
    section{  
      .shell-fluid{
        max-width: 100%;
        margin: auto;
        .range{
          .news-item{
            max-width:49%;
            margin-right: 2%;
            &:nth-child(2n) {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .page{
    section{  
      .shell-fluid{
        max-width: 100%;
        margin: auto;
        .range{
          .news-item{
            max-width:100%;
            margin-right: 0%;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Oprema.vue